import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 11 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 12\" id=\"icon-plus\"><path d=\"M6.572.25H4.428v4.428H0v2.144h4.428v4.428h2.144V6.822H11V4.678H6.572V.25Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol